import React from "react"
import { Heading, Box } from "rebass"

const HeadingBar = ({ children }) => (
  <Box
    py={4}
    sx={{ borderColor: "text" }}
    css={{
      textAlign: "center",
      borderTop: "2px solid",
    }}
  >
    <Heading variant="title">{children}</Heading>
  </Box>
)

export default HeadingBar
